import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Constant,ContentTypeValues, PlatFormType} from 'src/app/common/constant/constant';
import { NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Message, MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from 'src/app/services/api/api.service';
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import { LandingpageService } from "src/app/services/landingpage/landingpage.service";
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SuccessComponent } from 'src/app/components/common/success/success.component';
import { ManageListComponent } from 'src/app/components/common/manage-list/manage-list.component';
declare var $:any;

@Component({
  selector: 'app-manage-jobs',
  templateUrl: './manage-jobs.component.html',
  styleUrls: ['./manage-jobs.component.scss']
})
export class ManageJobsComponent implements OnInit {
  @Input() access: string = '';
  @Input() workstreamListsOptions: any = [];
  @Input() productsList: any = [];
  @Input() currentData: any;
  @Input() accessLevel:any = [];
  @Input() jcId: any = '';
  @Input() showDialog: boolean = false;
  @Output() jobCallback = new EventEmitter<void>();

  public user: any;
  public domainId;
  public userId;
  public roleId;
  public countryId;
  public teamId: string = localStorage.getItem('defaultTechSupportTeamId');
  public loading: boolean = false;
  public optionLoading: boolean = false;
  public jobForm: FormGroup;
  public jobFormSubmit = false;
  public jobFormValid = false;
  public jobExist = false;
  public addednewProduct: boolean = false;
  public jobFormTitle: string = 'Add New Job';
  public existError: string = '';
  public jobErrorIds: any = [];
  public jobOptionNameLists: any = [];
  public jobOptionValueLists: any = [{id: 0, name: 'Any'}];
  public jobDurationOptions: any = ['1 Hour', '1.5 Hours', '2 Hours', '2.5 Hours', '3 Hours',  '3.5 Hours', '4 Hours', '4.5 Hours', '5 Hours'];
  public jobtitle: string = '';
  public jobdescription: string = '';
  public manageTitle: string = 'Job Title and Description';
  public systemMsg: Message[];
  public jobDiscountValue: any = '';
  public discountValue: any = '';
  public discountValueInvalid: any = '';
  public discountValueError: string = 'Discount should not exceed more than 100%';
  public discountValueErrorFlag: boolean = false;
  public discountFocus: boolean = false;
  public baseApiUrl: string = "";
  public collabticApi: string = Constant.CollabticApiUrl;
  public searchVal: string = "";
  public itemLimit: any = 20;
  public itemOffset: any = 0;
  public apiData: Object;
  public headerFlag: boolean = false;
  public headerData: Object;
  public isAvailable = 1;

  get jf() { return this.jobForm.controls }

  constructor(
    private apiUrl: ApiService,
    private repairOrderApi: RepairOrderService,
    private commonApi: CommonService,
    private authenticationService: AuthenticationService,
    private landingpageServiceApi: LandingpageService,
    private formBuilder: FormBuilder,
    public messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    console.log('in manage job')
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;
    this.countryId = localStorage.getItem('countryId');
    let platformId = localStorage.getItem("platformId");
    if (platformId == null || platformId == 'null') {
      platformId = PlatFormType.Collabtic;
      //platformId=PlatFormType.MahleForum;
      //platformId=PlatFormType.CbaForum;
    }
    if (platformId == PlatFormType.Collabtic) {
      this.collabticApi = Constant.CollabticApiUrl;
    } else if (platformId == PlatFormType.MahleForum) {
      this.collabticApi = Constant.TechproMahleApi;
    } else if (platformId == PlatFormType.CbaForum) {
      this.collabticApi = Constant.CbaApiUri;
    } else if (platformId == PlatFormType.KiaForum) {
      this.collabticApi = Constant.KiaApiUri;
    } else {
      this.collabticApi = Constant.CollabticApiUrl;
    }

    let apiInfo = {
      'apiKey': Constant.ApiKey,
      'userId': this.userId,
      'domainId': this.domainId,
      'countryId': this.countryId,
      'isActive': 1,
      'searchKey': this.searchVal,
      'limit': this.itemLimit,
      'offset': this.itemOffset
    }

    this.apiData = apiInfo;
    this.headerData = {
      access: this.access,
      createAccess: false,
      profile: true,
      welcomeProfile: true,
      search: true,
      searchVal: "",
  };
    // setTimeout(() => { // Removed timeout due to issues with setupForm api calls
      this.baseApiUrl = this.apiUrl.apiCollabticBaseUrl();
    // }, 100);
    this.setupJobForm();
  }

  setupJobForm(item:any = '') {
    this.jobFormSubmit = false;
    this.jobFormValid = false;
    this.jobExist = false;
    this.existError = '';
    this.jobOptionNameLists = [];
    if(this.workstreamListsOptions?.length > 0) {
      let options = this.workstreamListsOptions[0].options;
      console.log(options)
      for(let opt of options) {
        let name = opt.name;
        let id = opt.id;
        this.jobOptionNameLists.push({id, name});
      }
    }

    console.log("currentData: ", this.currentData);
    
    let id = this.currentData?.id || 0;
    let optionName = this.currentData?.optionType || 4;
    let optionValueName = this.getOptionValueId(this.currentData) || 0;
    let jobcode = this.currentData?.jobCode || this.currentData?.jobcode || 1;
    let jobtitle = this.currentData?.jobtitle || "";
    let jobdescription = this.currentData?.jobdesc || "";
    let price = this.currentData?.unitPrice ||  "";
    let discount = this.currentData?.discount || "";
    let cost = this.currentData?.wdPrice || "0";
    let jobDuration = this.currentData?.jobDuration || "1 Hour";
    let qty = this.currentData?.qty || "1.00"
    this.isAvailable = this.currentData?.isAvailable ?? 1
    if(this.productsList?.length > 1 && !(this.currentData?.jobCode || this.currentData?.jobcode)) {
      let pjobcode = (this.productsList[0]?.jobCode && this.productsList[0]?.jobCode != undefined) || (this.productsList[0]?.jobcode && this.productsList[0]?.jobcode != undefined)  ? this.productsList[0]?.jobCode || this.productsList[0]?.jobcode || '1' : 0;
      jobcode = (pjobcode + jobcode)?.substring(0, 10); // limit to 10
    }
    
    this.jobForm = this.formBuilder.group({
      id,
      optionName,
      optionValueName,
      jobcode,
      jobtitle: [jobtitle, [Validators.required]],
      jobdescription,
      price,
      discount,
      cost,
      jobDuration,
      qty,
      isAvailable: this.isAvailable
    });

    if(optionName){
      this.onChangeNameOption({value: optionName, isInitialLoad: true});
    }
  }

  getOptionValueId(data:any) {
    let parsed = []
    if(data?.optionValues) {
      parsed = JSON.parse(data?.optionValues)
    }
    let dataArr = []
    if(Array.isArray(parsed)) {
      dataArr = parsed?.map(val => val.id)
    }
    if(dataArr?.includes("Any")){
      return 0
    }
    return dataArr?.[0] ? String(dataArr?.[0])  : 0
  }

  closeJobModal(data:any='') {
    this.jobOptionNameLists = [];
    this.jobOptionValueLists = [{id: 0, name: 'Any'}];
    this.jobForm.reset();
    if(this.access == 'job-rate') {
      this.addednewProduct = (this.accessLevel.create) ? false : true;
      this.apiUrl.jobandratecardNewButton = this.addednewProduct;
    }
    let emitData:any = {
      action: 'close'
    }
    if(data != '') {
      emitData = data;
    }
    this.jobCallback.emit(emitData);
  }

  jobFormAction(formAction) {
    this.jobFormSubmit = true;
    console.log("jobFormAction: ", this.jobFormSubmit,this.jobForm)
    let formValue = this.jobForm.value;
    if(this.jobForm.valid && formValue){
      let id = formValue.id;
      let optionType = 'Any', optionValueName = 'Any';
      optionType = formValue.optionName;
      let optionValueId = formValue.optionValueName;
      let optionValueData = [];
      let optValueIndex = this.jobOptionValueLists.findIndex(option => option.id == optionValueId);
      if(optValueIndex >= 0) {
        let optVal = this.jobOptionValueLists[optValueIndex];
        let valId = optVal.id.toString();
        let valName = optVal.name; 
        let optionValue = [{id: valId, name: valName}];
        optionValueData = optionValue?.map(a => a?.name)
        optionValueName = JSON.stringify(optionValue);
      }
      let optionTypeName = 'Any'
      let optNameIndex = this.jobOptionNameLists.findIndex(option => option.id == optionType);  
      if(optNameIndex >= 0) {
        optionTypeName = this.jobOptionNameLists[optNameIndex]?.name || 'Any'
      }   
      let jobcode = formValue.jobcode;
      let jobtitle = formValue.jobtitle;
      let jobdescription = formValue.jobdescription;
      let price = (formValue.price == '') ? 0 : formValue.price;
      price = (Math.abs(formValue.price)).toFixed(2);
      let priceShowOnly = price;
      let discount = (formValue.discount == '') ? 0 : formValue.discount;
      let wdPrice = (Math.abs(formValue.cost)).toFixed(2);
      let jobDuration = formValue.jobDuration;
      let hours = (Math.abs(formValue.qty)).toFixed(2);
      let isAvailable = formValue.isAvailable;
      let jobInfo = [{id, optionType, optionValueName, jobcode, jobtitle, jobdescription, price, priceShowOnly, discount, wdPrice, jobDuration, hours}];
      
      let apiFormData = new FormData();
      apiFormData.append('apiKey', Constant.ApiKey);
      apiFormData.append('userId', this.userId);
      apiFormData.append('domainId', this.domainId);
      apiFormData.append('contentTypeId', ContentTypeValues.RepairOrder);
      apiFormData.append('params', JSON.stringify(jobInfo));
      apiFormData.append('jcId', this.jcId);
      apiFormData.forEach((value,key) => {
        console.log(key+":"+value)
        return false;
      });

      this.repairOrderApi.updateJOBDetailsList(apiFormData).subscribe((response) => {
        this.jobFormSubmit = false;
        if(response.status=='Success') {
          let responseData = response.data;
          let jobData = responseData.jobInfo;
          if(Array.isArray(jobData) && jobData?.length) {
            jobData[0].isAvailable = isAvailable ?? 1
            jobData[0].optionTypeName = optionTypeName || 'Any'
            jobData[0].optionValue = optionValueData || []
          }
          let emitData:any = {
            action: 'new',
            response: jobData
          }
          const modalMsgRef = this.modalService.open(SuccessComponent, { backdrop: 'static', keyboard: false, centered: true });
          modalMsgRef.componentInstance.msg = response.message;
          setTimeout(() => {
            modalMsgRef.dismiss('Cross click');
            this.closeJobModal(emitData);          
          }, 2000);
        } else {
          this.loading=false;
        }
      });      
    }
  }

  oninputChange(event,type){
    if(type == 'title'){
      this.jobtitle = event.target.value;
    }
    else{
      this.jobdescription = event.target.value;
    }
  }
  
  jobCodeCheck(code, index:any = -1, productsLis:any=[], hId: any = -1) {
    let apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('userId', this.userId);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('contentTypeId', ContentTypeValues.RepairOrder);
    apiFormData.append('teamId', this.teamId);
    apiFormData.append('name', code);
    apiFormData.append('action', 'new');
    apiFormData.append('isValidateJobCode', '1');
    if(index >= 0) {
      apiFormData.append('id', productsLis.id);      
    }
    this.repairOrderApi.managejobType(apiFormData).subscribe((response) => {
      this.jobExist = (response.error) ? true : false;
      this.existError = (response.error) ? response.message : '';      
    });
  }

  onChangeNameOption(event) {
    console.log("onChangeNameOption: ", event);
    
    let id = event.value;
    this.jobOptionValueLists = [];
    if(!event?.isInitialLoad) {
      this.jobForm.patchValue({optionValueName: ''});
    }
    let loading = (id < 4) ? true : false;
    switch(id) {
      case 1:
        this.getCategoryData(undefined, event?.isInitialLoad ? 'init': '');
        break;
      case 2:
        this.getMfgList(event?.isInitialLoad ? 'init': '');
        break;
      case 3:
        this.getMakeModelsList(event?.isInitialLoad ? 'init': '');
        break;
      default:
        this.jobOptionValueLists = [{id: 0, name: 'Any'}];
        if(event?.isInitialLoad && this.currentData) {
          this.jobForm.patchValue({optionValueName: 0});
        }
        break;
    }
    this.optionLoading = loading;
  }

  // Get ThreadeCAtegory List
  getCategoryData(sitem:any = '', initLoad:any = '') {
    let apiUrl = `${this.baseApiUrl}${Constant.getThreadCategoryData}`;
    const apiData: any = new FormData();
    apiData.append("apiKey", Constant.ApiKey);
    apiData.append("domainId", this.domainId);
    apiData.append("countryId", '');
    apiData.append("userId", this.userId);
    apiData.append('workstreamsList', JSON.stringify([this.workstreamListsOptions[0].id]))
    apiData.append('access', 'thread');
    this.commonApi.apiCall(apiUrl, apiData).subscribe((response) => {
      console.log(response)
      this.optionLoading = false;
      let items = response.items;
      items.forEach((item, index) => {
        let id = parseInt(item.id);
        let name = item.name;
        let optionList = {id, name};
        this.jobOptionValueLists.push(optionList);
      });
      setTimeout(() => {
        if(initLoad == 'init' && this.currentData) {
          let optionValueName = parseInt(this.getOptionValueId(this.currentData) || '0');
          this.jobForm.patchValue({optionValueName});
          console.log("optionValueName: ", { optionValueName, jf: this.jobForm });
        }
        this.cdr?.detectChanges();
      }, 200);
    }, (error: any) => {
      setTimeout(() => {
        this.cdr?.detectChanges();
      }, 100);
    })
  }

  // Get Mfg List
  getMfgList(initLoad:any = '') {
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('makeName', '');
    this.landingpageServiceApi.getMfgList(apiFormData).subscribe((response) => {
      this.optionLoading = false;
      let mfgList = response.items;
      mfgList.forEach(item => {
        let id = parseInt(item.id);
        let name = item.name;
        let optionList = {id, name};
        this.jobOptionValueLists.push(optionList);
      }); 
      setTimeout(() => {
        if(initLoad == 'init' && this.currentData) {
          let optionValueName = parseInt(this.getOptionValueId(this.currentData) || '0');
          this.jobForm.patchValue({optionValueName});
        }
        this.cdr?.detectChanges();
      }, 100);    
    });
  }

  // Get Model List
  getMakeModelsList(initLoad:any = '') {
    let apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('workstreamsList', JSON.stringify([this.workstreamListsOptions[0].id]))
    apiFormData.append('access', 'thread');
    this.landingpageServiceApi.getProductMakeListsAPI(apiFormData).subscribe(      
      (response) => {
        this.optionLoading = false;
        if (response.status == 'Success') {
          let resultData = response.modelData;
          resultData.forEach(item => {
            let optionList = {id: item.id, name: item.makeName};
            this.jobOptionValueLists.push(optionList);
          });         
        }
        setTimeout(() => {
          if(initLoad == 'init' && this.currentData) {
            let optionValueName = this.getOptionValueId(this.currentData) || 0;
            this.jobForm.patchValue({optionValueName});
          }
          this.cdr?.detectChanges();
        }, 100);
      }
    );
  }

  isNumberKey(key,value,columnName){    
    var keycode = (key.which) ? key.which : key.keyCode;
    console.log(keycode);
    console.log(value.length)
    console.log(columnName)
    if(value.length==0 && (columnName == 'discountPrice' ||columnName == 'price' || columnName == 'hourlyrate')){
      if (keycode != 45 && keycode != 46 && keycode > 31
        && (keycode < 48 || keycode > 57))
         return false;
    }
    else{
      if (keycode != 46 && keycode > 31
        && (keycode < 48 || keycode > 57))
         return false;
    }   
  }

  onFieldChange(event, field) {
    console.log(event)
    let value = event.target.value;
    let discountPriceVal:any = '';
    let discountVal:any = 0;
    let price, cost:any = 0;
    let discountPrice:any;
    let updateFlag = false;
    switch(field) {
      case 'price':
        discountVal = this.jobForm.value.discount;
        if(value != '' && value > 0) {
          if(discountVal != '' && discountVal > 0) {
            price = value;
            discountPriceVal = discountVal;
            discountPrice = price*(discountPriceVal/100);
            discountPrice = price-discountPrice;
            cost = (Math.abs(discountPrice)).toFixed(2);
            price = (Math.abs(value)).toFixed(2);            
            updateFlag = true;
          }
        } else {
          price = (Math.abs(0)).toFixed(2);
          cost = price;       
          updateFlag = true;   
        }
        this.discountValueErrorFlag = (discountPriceVal <= 100) ? false : true;
        if(updateFlag && !this.discountValueErrorFlag) {
          this.jobForm.patchValue({price, cost});
        }
        break;
      case 'discountPrice':
        price = this.jobForm.value.price;
        console.log(value);
        if(value != '' && value != '-'){
          const discountControl = this.jobForm.get('discount');
          value = discountControl?.value;

          if (value !== null && value !== undefined && value !== '') {
            const num = parseFloat(value);
            if (!isNaN(num)) {
              discountControl?.setValue(num.toFixed(2));
            } else {
              discountControl?.setValue('');
            }
          }

          console.log('in'+`${(Math.abs(value)).toFixed(2)}`)
          let dval = `${(Math.abs(value)).toFixed(2)}`;
          discountVal =  dval;
          discountPriceVal = discountVal;          
          if(price != '' && price > 0) {
            discountPrice = price*(discountPriceVal/100);
            discountVal = price-discountPrice;
            discountPrice = price-discountPrice;
            cost = `${(Math.abs(discountPrice)).toFixed(2)}`;
            updateFlag = true;            
          }
        } else {
          if(price != '' && price != '-' && price >= 0) {
            price = 0;
            cost = price;            
          } else {
            price = 0;
          }
          cost = (Math.abs(price)).toFixed(2);
          updateFlag = true;          
        }
        this.discountValueErrorFlag = (value <= 100) ? false : true;
        if(updateFlag && !this.discountValueErrorFlag) {
          this.jobForm.patchValue({cost});
        }       
        break;
    }
  }

  focusDiscount() {
    $('#discountField').focus();
  }

  foucsInput(action, field) {
    if(action == 'focus') {
      switch(field) {
        case 'discountPrice':
          this.discountFocus = true;
          break;
      }
    } else {
      switch(field) {
        case 'discountPrice':
          this.discountFocus = false;
          break;
      }
    }
    
  }

  formatAmount(val) {
    let result = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'US',
      minimumFractionDigits: 0,
    }).format(Number(val));
  }

  formatDiscount() {
    const discountControl = this.jobForm.get('discount');
    let value = discountControl?.value;

    if (value !== null && value !== undefined && value !== '') {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        discountControl?.setValue(num.toFixed(2));
      } else {
        discountControl?.setValue('');
      }
    }
  }


}
